const gradients = {
  'rewards-bold': 'linear-gradient(90deg, #72D3A6 0%, #A3E1FF 100%)',
  'rewards-light': 'linear-gradient(270deg, #E8F8FF 0%, #F4FCF8 100%)',
  cobalt: 'linear-gradient(118deg, #4F71DD 0%, #0D32AA 31.96%, #051444 100%)',
};

export { gradients };
